import axios from 'axios'
import * as commonActions from '../../common.actions'
import getApiUrl from '../../helpers/api-urls'

//To DO
export const getEntitlementListAction = (memberAccountNo, dispatch, callback) => {
	const url = `${getApiUrl('member', 'getEntitlementList')}/${memberAccountNo}`
	dispatch(commonActions.setLoader(true))
	axios.get(url)
		.then(response => {
			dispatch(commonActions.setLoader(false))
			if (response && response.data && response.data.ResponseData) {
				callback(response.data.ResponseData)
				dispatch(commonActions.setEntitlementInfo(response.data.ResponseData))
			}
			else {
				dispatch(commonActions.setMessage(true, '1056'))
			}
		})
		.catch(() => {
			dispatch(commonActions.setMessage(true, '1056'))
			dispatch(commonActions.setLoader(false))
		})
}
